import React from 'react';
import Button from '@material-ui/core/Button';
import { TwitterIcon } from '../../images/icons';
import GetConfig from '../../helpers/GetConfig';
import { trackEvent } from '../../infrastructure/tracking/GoogleAnalytics';
import { useSelector } from 'react-redux';
import RootState from '../../types';
import { getUserStats } from '../../helpers';

interface TwitterButtonProps {
  gamesStarted: string;
  gamesFinished: string;
  currentStreak: string;
  levelsCompleted: string;
  totalPlayTime: string;
  highestPositionAllTime: string;
}

const TwitterButton: React.FC<TwitterButtonProps> = ({
  gamesStarted,
  gamesFinished,
  currentStreak,
  levelsCompleted,
  totalPlayTime,
  highestPositionAllTime,
}) => {
  const isWebView = useSelector((state: RootState) => state.isWebView.webView);
  const shareCode = useSelector((state: RootState) => state.user.shareCode);

  const { apiShareUrl } = GetConfig();

  const share = () => {
    const shareUrl = `${apiShareUrl}share/${shareCode}`;
    const shareText = getUserStats(
      gamesStarted,
      gamesFinished,
      currentStreak,
      levelsCompleted,
      totalPlayTime,
      highestPositionAllTime
    );

    const urlParam = shareUrl ? `&url=${shareUrl}` : '';
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}${urlParam}`;
    trackEvent('Share', 'Share Selected', 'Twitter');
    if (isWebView) {
      window.location.href = twitterUrl;
    } else {
      window.open(twitterUrl, 'Tweet', 'location=0,status=0,width=800,height=650');
    }
  };

  return (
    <Button
      classes={{
        root: 'TwitterBtn ShareBtn',
        label: 'BtnLabel',
      }}
      onClick={share}
    >
      <TwitterIcon />
    </Button>
  );
};

export default TwitterButton;
